import { render, staticRenderFns } from "./DramaThemeFlashPage.vue?vue&type=template&id=8d4d342e&"
import script from "./DramaThemeFlashPage.vue?vue&type=script&lang=ts&"
export * from "./DramaThemeFlashPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports